import React from "react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const BlogDetails = () => {
  const Base_URL = process.env.REACT_APP_BASE_URL;
  const Blog_URL = process.env.REACT_APP_BLOG_URL;
  const Customer_Review_Blog_URL = `${Base_URL}${Blog_URL}`;

  const [item, setItem] = useState("");
  const { id } = useParams();

  useEffect(() => {
    const getSingleBlog = async () => {
      const { data } = await axios.get(`${Customer_Review_Blog_URL}${id}/`);
      setItem(data);
    };
    getSingleBlog();
  }, [Customer_Review_Blog_URL, id]);

  return (
    <>
      <section id="prodetails" className="section-p1">
        <div className="single-pro-img">
          <img id="mainImg" src={item.image} width="100%" alt="" />
        </div>

        <div className="col-md-8">
          <div className="card-body text-start">
            <div className="blog-header">
              <div>
                <h2>{item.title}</h2>
                <span>{item.subtitle}</span>
              </div>
              <div>
                <p>
                  <b>Author : {item.author}</b>
                </p>
                <span>{item.pub_date}</span>
              </div>
            </div>

            <div style={{ marginTop: "15px" }}>
              {/* <strong>Blog Details:</strong> */}
              <div style={{ textAlign: "justify" }}>
                {/* <span>{item.description}</span> */}
                <div
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
